<template>
  <el-card>
    <div>
      <el-button icon="el-icon-arrow-left" @click="returnlist">取消</el-button>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="调显码" prop="code" label-width="100px">
          <el-input style="width: 350px;" prop="code" v-model="ruleForm.code" oninput="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title" label-width="100px">
          <el-input style="width: 350px;" v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content" label-width="100px">
          <quill-editor
            v-model="ruleForm.content"
            ref="myQuillEditor"
            class="editor"
            :options="editorOption"
            @change="onEditorChange($event)"
            @ready="onEditorReady($event)"
          ></quill-editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import qs from "qs";
export default {
  components: {
    quillEditor
  },
  data() {
    return {
      ruleForm: {},
      rules: {
        title: [
          {
            required: true,
            message: "此项为必填项",
            trigger: "red"
          },
          { min: 1, max: 100, message: '标题不长于一百字', trigger: 'blur' }
        ],
        code: [
          {
            required: true,
            message: "此项为必填项",
            trigger: "red"
          }
        ]
      },
      imageUrl: "",
      inputVisible: false,
      inputValue: "",
      tags: ["标签一"],
      detailContent: "", // 富文本内容
      editorOption: {}, // 富文本编辑器配置
      videoList: [
        {
          id: 0,
          videoSrc: require("../../../assets/video/01.mp4")
        }
      ]
    };
  },
  methods: {
    submitForm: function(formName) {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          var res = await this.$http.post(
            `/v1/message/addoredit`,
            qs.stringify(this.ruleForm)
          );
          var {code, data, message} = res.data;
          if (code == 0) {
            this.$router.push(`/message`);
            this.$message.success("添加/编辑成功");
          } else {
            this.$message.error(message);
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onEditorReady(instance) {
      // instance.setContent("");
      // instance.addListener("contentChange", () => {
      //   this.content = instance.getContent();
      // });
    },
    onEditorChange(event) {
      // console.log(event);
    },
    getinfo: async function() {
      var id = this.$route.query.id;
      if (id != undefined && id != null && id != "") {
        var res = await this.$http.get(`/v1/message/getById?id=${id}`);
        var { code, message, data } = res.data;
        if (code == 0) {
          this.ruleForm = data;
        }
      }
    },
    returnlist: function() {
      this.$router.push(`/message`);
    }
  },
  mounted() {
    this.getinfo();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/message-mg/messageadd.vue